/**
 *
 * SwitchViewButton
 *
 */

import React, { memo } from 'react';
function SwitchViewButton() {
  return <span />;
}

export default memo(SwitchViewButton);
